<template>
    <div>
        <div v-if="faqs.length > 0" id="faqList" class="faq-list" :class="noScroll ? '' : 'scroll-faq'">
            <div v-for="(question, key) in faqs" :id="'faq'+question.id" :ref="'faq'+question.id" :key="key" class="faq-question">
                <b-button class="toggle-reply" @click="toggleVisible(key)">
                    {{ question.question }}
                    <b-icon-arrow-up v-if="question.visible"></b-icon-arrow-up>
                    <b-icon-arrow-down v-else></b-icon-arrow-down>
                </b-button>
                <b-collapse v-model="question.visible">
                    <div class="mt-2 faq-content" v-html="question.answer"></div>
                </b-collapse>
                <p id="scrollAuxiliary" style="display: none; margin-top: 50px;">&nbsp;</p>
            </div>
        </div>
        <p v-else-if="notFound" class="text-center">Nicio întrebare găsită.</p>
        <p v-else class="text-center">Nicio întrebare frecventă disponibilă momentan.</p>
    </div>
</template>

<script>
    import { BIconArrowLeft, BCollapse, BButton, VBToggle, BFormGroup, BFormTextarea, BFormInput, BFormFile, BIconArrowDown, BIconArrowUp } from 'bootstrap-vue';
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import _ from "lodash";
    require('@/helpers/validations/validations')
    export default {
        components: {
            BIconArrowLeft,
            BCollapse, BButton, BFormGroup, BFormTextarea, BFormInput, BFormFile, BIconArrowDown, BIconArrowUp,
            ValidationProvider, ValidationObserver
        },
        directives: {
            'b-toggle': VBToggle
        },
        props: {
            faqs: {
                type: Array,
                default: null,
            },
            questionPressed: {
                type: Number,
                default: null,
            },
            noScroll: {
                type: Boolean,
                default: null,
            },
            notFound: {
                type: Boolean,
                default: null,
            },
        },
        data() {
            return {
            }
        },
        watch: {
            questionPressed: {
                handler: function() {
                    if(this.questionPressed) {
                        let faq = _.filter(this.faqs, v => v.id === this.questionPressed);
                        if(faq) {
                            faq[0].visible = true
                            let scroll = 'faq'+this.questionPressed
                            document.getElementById('scrollAuxiliary').style.display = 'block';
                            document.getElementById(scroll).scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
                            document.getElementById('scrollAuxiliary').style.display = 'none';
                            this.$emit('questionOpened')
                        }
                    }
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            toggleVisible(key) {
                this.faqs.forEach((item, index) => {
                    if(index !== key)
                        item.visible = false
                })
                this.faqs[key].visible = !this.faqs[key].visible
            }
        }
    }
</script>

<style scoped>
.toggle-reply{
    background: #545a6fb8;
    border: none;
    color: #fff;
    font-size: 14px;
    padding: 5px 20px;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.faq-question:not(:last-child){
    margin-bottom: 15px;
}
.faq-list{
    padding: 0 10px;
}
.scroll-faq{
    max-height: 280px;
    overflow: auto;
}
.faq-content >>> h1{
    font-size: 18px;
}
.faq-content >>> h2{
    font-size: 16px;
}
.faq-content >>> h3{
    font-size: 14px;
}
.faq-content >>> p{
    font-size: 13px;
}
.faq-content >>> ul{
    font-size: 13px;
    padding-left: 15px;
    list-style: disc;
    color: var(--mainColorText);
}
.faq-content{
    padding: 0 20px;
}
</style>
